export default __webpack_public_path__ + "static/media/hexofy-icon.ef6dc709.svg";